export enum SSLInspectionStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  BASE = 'base',
}

export type SSLInspectionResolvedState = Exclude<
  SSLInspectionStatus,
  SSLInspectionStatus.BASE
>

export interface SSLInspectionData {
  sslInspection: SSLInspectionStatus
}

export interface GetSSLInspectionConfigResponse {
  data: SSLInspectionData
}

export interface SSLInspectionApiValue {
  state: SSLInspectionResolvedState
  inheritsFromBase: boolean
}

export interface SSLInspectionUpdateStateValue {
  state: SSLInspectionResolvedState
  inheritsFromBase?: never
}

export interface SSLInspectionUpdateInheritValue {
  inheritsFromBase: true
  state?: never
}

export interface GetSSLInspectionConfigApiResponse {
  data: {
    sslInspection: SSLInspectionApiValue
  }
}

export interface UpdateSSLInspectionSchemaPayload {
  data: {
    sslInspection:
      | SSLInspectionUpdateStateValue
      | SSLInspectionUpdateInheritValue
  }
}
